import React from 'react';
import { COLORS } from 'tanda-components';
import Logo from 'tanda-components/Logo';
import styles from './loader.scss';

export default function Loader() {
  return (
    <div className={styles.loader}>
      <div className={styles.logo}>
        <Logo color={COLORS.WHITE} background={COLORS.BLUE} />
      </div>
      <p className={styles.text}>Loading...</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Loader.jsx